
/*
授权:
http://proj205dev.anoah.com/user/api/public/account/user/uploadAuth?userid=1
直传:
https://proj205dev.anoah.com/upload/api2/jwt/Upload2/upload_md5/?file_md5=f0f89e0838e99e590c2257e6f075b308&file_name=0011.jpg&user_id=1&mo_authority_token=b72a95aeac0ab1785c738c045f383f7e

上传完成后:
https://proj205dev.anoah.com/upload/api2/jwt/Upload2/upload_finish/?name=0011.jpg&file_md5=f0f89e0838e99e590c2257e6f075b308&file_name=0011.jpg&user_id=1&mo_authority_token=b72a95aeac0ab1785c738c045f383f7e&raw={"uid":1558662231615}&signature_info_token=fc7b24e33b781c74968c6c2089d0e5bc
*/

// import ppp from '../../yxpapi/yxpapi/index.js';
// window.yxpapi = ppp;

let opt = {
    // baseURL: 'http://edu-test1.anoah.com',
};

if (window.Vue && window.Vue.prototype.$message) {
    opt['toast'] = (p) => { window.Vue.prototype.$message(Object.assign({}, p, { duration: 2000 })); };
}

let api = new window.yxpapi.API({
    // 1,取受权地址
    uploadAuth: {
        url: '/user/api/public/account/user/uploadAuth_java',
        method: 'get',
        options: {
            auth: true,
            // errorTip: false,
            format: true,
        },
    },
    uploadMd5: {
        url: '/upload/api2/jwt/Upload2/upload_md5',
        method: 'post',
        options: {
            auth: true,
            //  errorTip: false,
            format: true,
            headers: {
                // 'Content-Type': 'application/json; charset=utf-8',
            },
        },
    },
    upload: {
        url: '',
        method: 'upload',
        options: {
            auth: false,
            //  errorTip: false,
            format: true,
            timeout: 60000 * 60, // 1小时
            alien: true,
        },
        before: function (param, foo) {
            let m = {};
            m.url = this.apis.upload.url;
            foo(Object.assign({}, param, m));
        },
    },
    uploadFinish: {
        url: '/upload/api2/jwt/Upload2/upload_finish',
        method: 'get',
        options: {
            auth: false,
            //  errorTip: false,
        },
    },
}, opt);

let api2 = new window.yxpapi.API({
    fileUpload: {
        url: '/file/upload',
        method: 'upload',
        options: {
            auth: true,
            timeout: 60 * 60 * 1000,
            errorTip: false,
            // format: true,
        },
        before: function (param, foo) {
            let m = {};
            m.url = this.apis.fileUpload.url;
            if (this.apis.fileUpload.multimedia) {
                m.options = {
                    auth: true,
                    timeout: 60 * 60 * 1000,
                    errorTip: false, // 上传不出错不启用统一提示，不然会引起回调错误
                };
                if (typeof param.options !== 'undefined') {
                    m.options.auth = typeof param.options.auth !== 'undefined' ? param.options.auth : m.options.auth;
                    m.options.timeout = typeof param.options.timeout !== 'undefined' ? param.options.timeout : m.options.timeout;
                }
                param.options = Object.assign(param.options, m.options);

                m.options.headers = { 'multimedia': this.apis.fileUpload.multimedia };
                param.options.headers = Object.assign((param.options.headers || {}), m.options.headers);
            }
            param.url = m.url;
            foo(param);
        },
    },
}, opt);

// 断点续传的接口
let api3 = new window.yxpapi.API({

    // 获取已上传的文件大小 http://yapi.dev.anoah.com/project/549/interface/api/31706
    getChunkedFileSize: {
        url: '',
        method: 'post',
        before: (me, setParamFun) => {
            me.url = me.data.options.url;
            me.data = null;
            setParamFun(me);
        },
        options: {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        },
    },
    // Stream文件断点续传 模块分组 + 类型 http://yapi.dev.anoah.com/project/549/interface/api/31699
    uploadResume: {
        url: '',
        method: 'upload',
        before: (me, setParamFun) => {
            me.url = me.data.options.url;
            me.options.headers = {
                Range: me.data.options.Range,
            };
            me.options.setCancel = me.data.options.setCancel;
            me.data = me.data.options.data;
            setParamFun(me);
        },
        options: {
            headers: {
            },
        },
    },
}, opt);

// 阿里直传
let api4 = new window.yxpapi.API({

    // 获取上传sts凭证 http://yapi.dev.anoah.com/project/549/interface/api/72242
    getUploadSts: {
        url: '/file/getUploadSts',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/json',
            },
        },
        before: function (param, foo) {
            let m = {};
            m.url = this.apis.getUploadSts.url;
            foo(Object.assign({}, param, m));
        },
    },
    // 完成sts上传 http://yapi.dev.anoah.com/project/549/interface/api/72263
    finishStsUpload: {
        url: '/file/finishStsUpload',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/json',
            },
        },
        before: function (param, foo) {
            let m = {};
            m.url = this.apis.finishStsUpload.url;
            foo(Object.assign({}, param, m));
        },
    },
    // 提交多媒体处理任务 http://yapi.dev.anoah.com/project/1010/interface/api/38333
    SubmitMediaTask: {
        url: '/api/media-support/task/submitTask',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    },
}, opt);

export default api;
export { api, api2, api3, api4 };
